// Flow Rate (Volumetric) units with conversion factors to cubic meters per second (m³/s)
export const flowRateUnits = [
  { id: 'cubic-meter-per-second', name: 'Cubic Meter/Second', symbol: 'm³/s', plural: 'Cubic Meters/Second', factor: 1 },
  { id: 'cubic-meter-per-minute', name: 'Cubic Meter/Minute', symbol: 'm³/min', plural: 'Cubic Meters/Minute', factor: 0.01666666667 },
  { id: 'cubic-meter-per-hour', name: 'Cubic Meter/Hour', symbol: 'm³/h', plural: 'Cubic Meters/Hour', factor: 0.000277777778 },
  { id: 'cubic-meter-per-day', name: 'Cubic Meter/Day', symbol: 'm³/d', plural: 'Cubic Meters/Day', factor: 0.00001157407 },
  { id: 'liter-per-second', name: 'Liter/Second', symbol: 'L/s', plural: 'Liters/Second', factor: 0.001 },
  { id: 'liter-per-minute', name: 'Liter/Minute', symbol: 'L/min', plural: 'Liters/Minute', factor: 0.00001666667 },
  { id: 'liter-per-hour', name: 'Liter/Hour', symbol: 'L/h', plural: 'Liters/Hour', factor: 0.000000277778 },
  { id: 'milliliter-per-second', name: 'Milliliter/Second', symbol: 'mL/s', plural: 'Milliliters/Second', factor: 0.000001 },
  { id: 'milliliter-per-minute', name: 'Milliliter/Minute', symbol: 'mL/min', plural: 'Milliliters/Minute', factor: 1.6666667e-8 },
  { id: 'gallon-us-per-minute', name: 'Gallon (US)/Minute', symbol: 'gpm', plural: 'Gallons (US)/Minute', factor: 0.0000630902 },
  { id: 'gallon-us-per-hour', name: 'Gallon (US)/Hour', symbol: 'gph', plural: 'Gallons (US)/Hour', factor: 0.00000105150 },
  { id: 'gallon-uk-per-minute', name: 'Gallon (UK)/Minute', symbol: 'gpm', plural: 'Gallons (UK)/Minute', factor: 0.0000757682 },
  { id: 'cubic-foot-per-second', name: 'Cubic Foot/Second', symbol: 'ft³/s', plural: 'Cubic Feet/Second', factor: 0.0283168466 },
  { id: 'cubic-foot-per-minute', name: 'Cubic Foot/Minute', symbol: 'cfm', plural: 'Cubic Feet/Minute', factor: 0.000471947 },
  { id: 'cubic-foot-per-hour', name: 'Cubic Foot/Hour', symbol: 'ft³/h', plural: 'Cubic Feet/Hour', factor: 0.00000786579 },
  { id: 'cubic-inch-per-second', name: 'Cubic Inch/Second', symbol: 'in³/s', plural: 'Cubic Inches/Second', factor: 0.0000163871 },
  { id: 'barrel-per-day', name: 'Barrel (Oil)/Day', symbol: 'bbl/d', plural: 'Barrels (Oil)/Day', factor: 0.00000184013 },
  { id: 'barrel-per-hour', name: 'Barrel (Oil)/Hour', symbol: 'bbl/h', plural: 'Barrels (Oil)/Hour', factor: 0.0000441631 },
];

export const popularFlowRateConversions = [
  { from: 'liter-per-minute', to: 'gallon-us-per-minute' },
  { from: 'gallon-us-per-minute', to: 'liter-per-minute' },
  { from: 'cubic-meter-per-hour', to: 'gallon-us-per-minute' },
  { from: 'cubic-foot-per-minute', to: 'liter-per-second' },
  { from: 'liter-per-second', to: 'cubic-meter-per-hour' },
  { from: 'gallon-us-per-minute', to: 'cubic-foot-per-minute' },
  { from: 'barrel-per-day', to: 'liter-per-minute' },
  { from: 'cubic-meter-per-second', to: 'liter-per-second' },
];

export const getUnitById = (id) => flowRateUnits.find(unit => unit.id === id);

export const convertFlowRate = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert flow rate units and learn the conversion formula.`;
};
